import { ADD_TASK_BY_ID, ADD_TASK_BY_ID_SUCCESS, ALL_HIGHLIGHTERS, ALL_HIGHLIGHTERS_SUCCESS, CHANGE_ESTIMATION_TIME, CREATE_PROJECT_FAIL, CREATE_PROJECT_ONE, CREATE_PROJECT_ONE_SUCCESS, CREATE_PROJECT_TWO, CREATE_PROJECT_TWO_SUCCESS, EDIT_PROJECT_BY_ID, EDIT_PROJECT_BY_ID_SUCCESS, EDIT_STAGE_BY_ID, EDIT_STAGE_BY_ID_SUCCESS, EDIT_TASK_BY_ID, EDIT_TASK_BY_ID_SUCCESS, ELAPSEDTIME, GET_ALL_BLUEPRINT, GET_ALL_BLUEPRINT_SUCCESS, GET_ALL_DUPLICATE_SUBTASK, GET_ALL_DUPLICATE_SUBTASK_FAILURE, GET_ALL_DUPLICATE_SUBTASK_SUCCESS, GET_ALL_NEEDINFO, GET_ALL_NEEDINFO_SUCCESS, GET_ALL_PROJECT, GET_ALL_PROJECT_MASTERDATA, GET_ALL_PROJECT_MASTERDATA_SUCCESS, GET_ALL_PROJECT_NO_PAGINATION, GET_ALL_PROJECT_NO_PAGINATION_SUCCESS, GET_ALL_PROJECT_SUCCESS, GET_ALL_REVERT_HISTORY, GET_ALL_REVERT_HISTORY_SUCCESS, GET_ALL_SUBTASK, GET_ALL_SUBTASK_FAILURE, GET_ALL_SUBTASK_SAME_TASK, GET_ALL_SUBTASK_SAME_TASK_FAILURE, GET_ALL_SUBTASK_SAME_TASK_SUCCESS, GET_ALL_SUBTASK_SUCCESS, GET_ALL_SUBTASK_SUMMARY, GET_ALL_SUBTASK_SUMMARY_FAILURE, GET_ALL_SUBTASK_SUMMARY_SUCCESS, GET_ALL_TASK_BY_STAGE, GET_ALL_TASK_BY_STAGE_ID, GET_ALL_TASK_BY_STAGE_ID_SUCCESS, GET_ALL_TASK_VIEW, GET_ALL_TASK_VIEW_SUCCESS, GET_GENERAL_TIME_TRACKING, GET_GENERAL_TIME_TRACKING_SUCCESS, GET_HIGHLIGHT_BY_VIEW, GET_HIGHLIGHT_BY_VIEW_SUCCESS, GET_HISTORY_BY_VIEW, GET_HISTORY_BY_VIEW_SUCCESS, GET_LATEST_TIME_BY_ID, GET_LATEST_TIME_BY_ID_SUCCESS, GET_PROJECT_BY_ID, GET_PROJECT_BY_ID_SUCCESS, GET_REVERT_HISTORY, GET_REVERT_HISTORY_SUCCESS, GET_SOW_CHECKLIST, GET_SOW_CHECKLIST_SUCCESS, GET_SOW_FIELDS, GET_SOW_FIELDS_SUCCESS, GET_STAGES_BY_ID, GET_STAGES_BY_ID_SUCCESS, GET_STAGE_BY_PROJECT_ID, GET_STAGE_BY_PROJECT_ID_SUCCESS, GET_STAGE_TIME_SUMMERY, GET_STAGE_VIEW, GET_STAGE_VIEW_SUCCESS, GET_TASK_BY_ID, GET_TASK_BY_ID_SUCCESS, GET_TASK_BY_PROJECT_ID, GET_TASK_BY_PROJECT_ID_SUCCESS, GET_TASK_BY_STAGE_ID, GET_TASK_BY_STAGE_ID_SUCCESS, GET_TIME_BY_ID, GET_TIME_BY_ID_SUCCESS, GET_TIME_BY_PROJECT_ID, GET_TIME_BY_PROJECT_ID_SUCCESS, GET_TIME_BY_STAGE_ID, GET_TIME_BY_STAGE_ID_SUCCESS, GET_TIME_SUMMERY, GET_TIME_SUMMERY_SUCCESS, GET_TIME_TRACKING, GET_TIME_TRACKING_SUCCESS, NEED_INFO, NEED_INFO_SUCCESS, PROJECT_ACTION, PROJECT_ACTION_SUCCESS, SET_STAGE_BY_UPDATE_CUSTOM_ORDER, SET_STAGE_BY_UPDATE_CUSTOM_ORDER_SUCCESS, STAGE_ACTION, STAGE_ACTION_SUCCESS, START_TRACKING, START_TRACKING_SUCCESS, STOP_TRACKING, STOP_TRACKING_SUCCESS, UPDATE_ACTION_STATUS_TO_ANY, UPDATE_ACTION_STATUS_TO_ANY_SUCCESS, UPDATE_PROJECT_ATTACHMENT, UPDATE_PROJECT_ROW, UPDATE_STAGE_ATTACHMENT, UPDATE_STAGE_ROW, UPDATE_TASK_ATTACHMENT, UPDATE_TASK_ROW, GET_STAGE_COUNTS_BY_DATE, GET_STAGE_COUNTS_BY_DATE_SUCCESS, CREATE_MEETING_HISTORY, CREATE_MEETING_HISTORY_SUCCESS, GET_ALL_MEETING_HISTORY, GET_ALL_MEETING_HISTORY_SUCCESS, UPDATE_MEETING_HISTORY, UPDATE_MEETING_HISTORY_SUCCESS, CREATE_CONTRACT, CREATE_CONTRACT_SUCCESS, UPDATE_CONTRACT, UPDATE_CONTRACT_SUCCESS, DELETE_CONTRACT, DELETE_CONTRACT_SUCCESS, GET_ALL_CONTRACTS, GET_ALL_CONTRACTS_SUCCESS } from '../storeTypes';

export const getAllProjectMasterData = (payload) => {
    return {
        type: GET_ALL_PROJECT_MASTERDATA,
        payload: payload,
    }
};

export const getAllProjectMasterDataSuccess = (payload) => {
    // console.log(payload, "check11");
    return {
        type: GET_ALL_PROJECT_MASTERDATA_SUCCESS,
        payload: payload,
    }
};

export const getAllProjectNoPagination = (payload) => {
    return {
        type: GET_ALL_PROJECT_NO_PAGINATION,
        payload: payload
    }
}

export const getAllProjectNoPaginationSuccess = (payload) => {
    return {
        type: GET_ALL_PROJECT_NO_PAGINATION_SUCCESS,
        payload: payload
    }
}

export const editProjectById = (payload, Id, fieldName) => {
    return {
        type: EDIT_PROJECT_BY_ID,
        payload,
        Id,
        fieldName
    }
}

export const editProjectByIdSuccess = (payload) => {
    return {
        type: EDIT_PROJECT_BY_ID_SUCCESS,
        payload
    }
}
export const editStageById = (payload, Id, fieldName, callback) => {
    return {
        type: EDIT_STAGE_BY_ID,
        payload,
        Id,
        fieldName,
        callback
    }
}

export const editStageByIdSuccess = (payload) => {
    return {
        type: EDIT_STAGE_BY_ID_SUCCESS,
        payload
    }
}

export const getTaskByProjectId = (payload) => {
    return {
        type: GET_TASK_BY_PROJECT_ID,
        payload
    }
}
export const getTaskByProjectIdSuccess = (payload) => {
    return {
        type: GET_TASK_BY_PROJECT_ID_SUCCESS,
        payload
    }
}

export const getTaskByStageId = () => {
    return {
        type: GET_TASK_BY_STAGE_ID
    }
}
export const getTaskByStageIdSuccess = (payload) => {
    return {
        type: GET_TASK_BY_STAGE_ID_SUCCESS,
        payload
    }
}
export const getAllTaskViewByStageId = (id) => {
    return {
        type: GET_ALL_TASK_BY_STAGE_ID,
        id
    }
}
export const getAllTaskViewByStage = (id) => {
    return {
        type: GET_ALL_TASK_BY_STAGE,
        id
    }
}
export const getAllTaskViewByStageIdSuccess = (payload) => {
    return {
        type: GET_ALL_TASK_BY_STAGE_ID_SUCCESS,
        payload
    }
}
export const getStageByProjectId = (payload) => {
    return {
        type: GET_STAGE_BY_PROJECT_ID,
        payload
    }
}
export const getStageByProjectIdSuccess = (payload) => {
    return {
        type: GET_STAGE_BY_PROJECT_ID_SUCCESS,
        payload
    }
}

export const getStageByCustomOrder = (payload, funC) => {
    return {
        type: SET_STAGE_BY_UPDATE_CUSTOM_ORDER,
        payload,
        funC
    }
}
export const getStageByCustomOrderSuccess = (payload) => {
    return {
        type: SET_STAGE_BY_UPDATE_CUSTOM_ORDER_SUCCESS,
        payload
    }
}





export const needInfo = (payload, Id) => {
    return {
        type: NEED_INFO,
        payload,
        Id
    }
}

export const needInfoSuccess = (payload) => {
    return {
        type: NEED_INFO_SUCCESS,
        payload
    }
}

export const stageAction = (payload, Id) => {
    return {
        type: STAGE_ACTION,
        payload,
        Id
    }
}

export const stageActionSuccess = (payload) => {
    return {
        type: STAGE_ACTION_SUCCESS,
        payload
    }
}

export const projectAction = (payload, Id) => {
    return {
        type: PROJECT_ACTION,
        payload,
        Id
    }
}

export const projectActionSuccess = (payload) => {
    return {
        type: PROJECT_ACTION_SUCCESS,
        payload
    }
}

export const editTaskById = (payload, Id, fieldName) => {
    return {
        type: EDIT_TASK_BY_ID,
        payload,
        Id,
        fieldName
    }
}
export const editTaskByIdSuccess = (payload) => {
    return {
        type: EDIT_TASK_BY_ID_SUCCESS,
        payload
    }
}
export const addTaskById = (payload, Id) => {
    return {
        type: ADD_TASK_BY_ID,
        payload,
        Id
    }
}
export const addTaskByIdSuccess = (payload) => {
    return {
        type: ADD_TASK_BY_ID_SUCCESS,
        payload
    }
}
export const getAllBlueprint = (payload) => {
    return {
        type: GET_ALL_BLUEPRINT,
        payload: payload,

    }
};

export const getAllBlueprintSuccess = (payload) => {
    return {
        type: GET_ALL_BLUEPRINT_SUCCESS,
        payload: payload,
    }
};
export const createStepOne = (payload, formik) => {
    return {
        type: CREATE_PROJECT_ONE,
        payload: payload,
        formik: formik, // Pass formik as an argument
    };
};
export const createStepOneSuccess = (payload) => {
    return {
        type: CREATE_PROJECT_ONE_SUCCESS,
        payload: payload,
    }
};
export const ProjectFail = (payload) => {
    return {
        type: CREATE_PROJECT_FAIL,
        payload: payload,
    }
}
export const createStepTwo = (payload, params, formik, Callback) => {
    return {
        type: CREATE_PROJECT_TWO,
        payload: payload,
        params: params,
        formik: formik,
        Callback
    }
}
export const createStepTwoSuccess = (payload) => {
    return {
        type: CREATE_PROJECT_TWO_SUCCESS,
        payload: payload
    }
}
export const getProjectById = (id) => {
    return {
        type: GET_PROJECT_BY_ID,
        payload: id
    }
}
export const getProjectByIdSuccess = (payload) => {
    return {
        type: GET_PROJECT_BY_ID_SUCCESS,
        payload: payload
    }
}
export const GetTimeById = (id) => {
    return {
        type: GET_TIME_BY_ID,
        payload: id
    }
}
export const GetTimeByIdSuccess = (payload) => {
    return {
        type: GET_TIME_BY_ID_SUCCESS,
        payload: payload
    }
}
export const GetTimeByStageId = (id) => {
    return {
        type: GET_TIME_BY_STAGE_ID,
        payload: id
    }
}
export const GetTimeByStageIdSuccess = (payload) => {
    return {
        type: GET_TIME_BY_STAGE_ID_SUCCESS,
        payload: payload
    }
}
export const GetTimeByProjectId = (id) => {
    return {
        type: GET_TIME_BY_PROJECT_ID,
        payload: id
    }
}
export const GetTimeByProjectIdSuccess = (payload) => {
    return {
        type: GET_TIME_BY_PROJECT_ID_SUCCESS,
        payload: payload
    }
}
export const GetLatestTimeById = (id) => {
    return {
        type: GET_LATEST_TIME_BY_ID,
        payload: id
    }
}
export const GetLatestTimeByIdSuccess = (payload) => {
    return {
        type: GET_LATEST_TIME_BY_ID_SUCCESS,
        payload: payload
    }
}
export const getStagesById = (id) => {
    return {
        type: GET_STAGES_BY_ID,
        payload: id
    }
}
export const getStagesByIdSuccess = (payload) => {
    return {
        type: GET_STAGES_BY_ID_SUCCESS,
        payload: payload
    }
}
export const getTaskById = (taskId) => {
    // console.log("stageview--",id);
    return {
        type: GET_TASK_BY_ID,
        taskId
    }
}
export const getTaskByIdSuccess = (payload) => {
    // console.log("stageView---");
    return {
        type: GET_TASK_BY_ID_SUCCESS,
        payload: payload
    }
}
export const getSowChecklist = (payload) => {
    return {
        type: GET_SOW_CHECKLIST,
        payload: payload
    }
}
export const getSowChecklistSuccess = (payload) => {
    return {
        type: GET_SOW_CHECKLIST_SUCCESS,
        payload: payload
    }
}
export const getSowFields = (payload) => {
    return {
        type: GET_SOW_FIELDS,
        payload: payload
    }
}
export const getSowFieldsSuccess = (payload) => {
    return {
        type: GET_SOW_FIELDS_SUCCESS,
        payload: payload
    }
}
export const GetProjectList = (payload) => {
    return {
        type: GET_ALL_PROJECT,
        payload: payload,
    }
}
export const UpdateProjectRow = (payload) => {
    return {
        type: UPDATE_PROJECT_ROW,
        payload: payload,
    }
}
export const UpdateProjectAttachment = (payload) => {
    return {
        type: UPDATE_PROJECT_ATTACHMENT,
        payload,
    }
}
export const UpdateStageAttachment = (payload) => {
    return {
        type: UPDATE_STAGE_ATTACHMENT,
        payload,
    }
}
export const UpdateTaskAttachment = (payload) => {
    return {
        type: UPDATE_TASK_ATTACHMENT,
        payload,
    }
}
export const UpdateStageRow = (payload) => {
    return {
        type: UPDATE_STAGE_ROW,
        payload: payload,
    }
}
export const UpdateTaskRow = (payload) => {
    return {
        type: UPDATE_TASK_ROW,
        payload: payload,
    }
}
export const GetProjectListSuccess = (payload) => {
    return {
        type: GET_ALL_PROJECT_SUCCESS,
        payload: payload
    }
}
export const GetAllStageView = (payload) => {
    return {
        type: GET_STAGE_VIEW,
        payload: payload,
    }
}
export const GetAllStageViewSuccess = (payload) => {
    return {
        type: GET_STAGE_VIEW_SUCCESS,
        payload: payload
    }
}

export const GetAllTaskView = (payload) => {
    return {
        type: GET_ALL_TASK_VIEW,
        payload: payload,
    }
}

export const GetAllTaskViewSuccess = (payload) => {
    return {
        type: GET_ALL_TASK_VIEW_SUCCESS,
        payload: payload

    }
}
export const StartTracking = (payload, callback) => {
    return {
        type: START_TRACKING,
        payload: payload,
        callback
    }
}
export const StartTrackingSuccess = (payload) => {
    return {
        type: START_TRACKING_SUCCESS,
        payload: payload
    }
}
export const StopTracking = (payload, id, Callback) => {
    return {
        type: STOP_TRACKING,
        payload: payload,
        id: id,
        Callback
    }
}
export const StopTrackingSuccess = (payload) => {
    return {
        type: STOP_TRACKING_SUCCESS,
        payload: payload
    }
}

export const getAllHighlighters = () => {
    return {
        type: ALL_HIGHLIGHTERS,
    }
}

export const getAllHighlightersSuccess = (payload) => {
    return {
        type: ALL_HIGHLIGHTERS_SUCCESS,
        payload: payload
    }
}

export const getHighlighterByView = (view) => {
    return {
        type: GET_HIGHLIGHT_BY_VIEW,
        view
    }
}
export const getHighlighterByViewSuccess = (payload) => {
    return {
        type: GET_HIGHLIGHT_BY_VIEW_SUCCESS,
        payload
    }
}
export const GetAllNeedInfo = (payload) => {
    return {
        type: GET_ALL_NEEDINFO,
        payload,
    }
}

export const GetAllNeedInfoSuccess = (payload) => {
    return {
        type: GET_ALL_NEEDINFO_SUCCESS,
        payload

    }
}
export const getHistoryByView = (payload) => {
    return {
        type: GET_HISTORY_BY_VIEW,
        payload
    }
}

export const getHistoryByViewSuccess = (payload) => {
    return {
        type: GET_HISTORY_BY_VIEW_SUCCESS,
        payload
    }
}
export const getRevertHistoryByView = (payload, Callback) => {
    return {
        type: GET_REVERT_HISTORY,
        payload,
        Callback
    }
}

export const getRevertHistoryByViewSuccess = (payload) => {
    return {
        type: GET_REVERT_HISTORY_SUCCESS,
        payload,
    }
}
export const getAllRevertHistory = (payload, Callback) => {
    return {
        type: GET_ALL_REVERT_HISTORY,
        payload,
        Callback
    }
}

export const getAllRevertHistorySuccess = (payload) => {
    return {
        type: GET_ALL_REVERT_HISTORY_SUCCESS,
        payload,
    }
}
export const changeEstimationTime = (payload, taskId) => {
    return {
        type: CHANGE_ESTIMATION_TIME,
        payload,
        taskId
    }
}

export const changeElapsedTime = (payload) => {
    return {
        type: ELAPSEDTIME,
        payload
    }
}


export const getTimeSummery = (payload) => {
    return {
        type: GET_TIME_SUMMERY,
        payload
    }
}
export const getStageTimeSummery = (payload) => {
    return {
        type: GET_STAGE_TIME_SUMMERY,
        payload
    }
}
export const getTimeSummerySuccess = (payload) => {

    return {
        type: GET_TIME_SUMMERY_SUCCESS,
        payload
    }
}

export const getTimeTracking = () => {

    return {
        type: GET_TIME_TRACKING,
    }
}
export const getTimeTrackingSuccess = (payload) => {

    return {
        type: GET_TIME_TRACKING_SUCCESS,
        payload
    }
}
export const getGeneralTimeTracking = (payload) => {

    return {
        type: GET_GENERAL_TIME_TRACKING,
        payload
    }
}
export const getGeneralTimeTrackingSuccess = (payload) => {

    return {
        type: GET_GENERAL_TIME_TRACKING_SUCCESS,
        payload
    }
}

export const getAllSubtask = (payload) => {

    return {
        type: GET_ALL_SUBTASK,
        payload
    }
}
export const getAllSubtaskSuccess = (payload) => {

    return {
        type: GET_ALL_SUBTASK_SUCCESS,
        payload
    }
}
export const getAllSubtaskFailure = (payload) => {

    return {
        type: GET_ALL_SUBTASK_FAILURE,
        payload
    }
}
export const getAllSubtaskSummary = (payload) => {

    return {
        type: GET_ALL_SUBTASK_SUMMARY,
        payload
    }
}
export const getAllSubtaskSummarySuccess = (payload) => {

    return {
        type: GET_ALL_SUBTASK_SUMMARY_SUCCESS,
        payload
    }
}
export const getAllSubtaskSummaryFailure = (payload) => {

    return {
        type: GET_ALL_SUBTASK_SUMMARY_FAILURE,
        payload
    }
}

export const getAllSubtasksOfSameTask = (payload) => {

    return {
        type: GET_ALL_SUBTASK_SAME_TASK,
        payload
    }
}
export const getAllSubtasksOfSameTaskSuccess = (payload) => {

    return {
        type: GET_ALL_SUBTASK_SAME_TASK_SUCCESS,
        payload
    }
}

export const getAllSubtasksOfSameTaskFailure = (payload) => {

    return {
        type: GET_ALL_SUBTASK_SAME_TASK_FAILURE,
        payload
    }
}
export const getAllDuplicateSubtasks = (taskId) => {

    return {
        type: GET_ALL_DUPLICATE_SUBTASK,
        taskId
    }
}
export const getAllDuplicateSubtasksSuccess = (payload) => {

    return {
        type: GET_ALL_DUPLICATE_SUBTASK_SUCCESS,
        payload
    }
}
export const getAllDuplicateSubtasksFailure = (taskId) => {

    return {
        type: GET_ALL_DUPLICATE_SUBTASK_FAILURE,
        taskId
    }
}
export const updateActionStatusToAny = (payload) => {
    return {
        type: UPDATE_ACTION_STATUS_TO_ANY,
        payload
    }
}
export const updateActionStatusToAnySuccess = (payload) => {
    return {
        type: UPDATE_ACTION_STATUS_TO_ANY_SUCCESS,
        payload
    }
}
export const getStageCountsByDate = (payload) => {
    return {
        type: GET_STAGE_COUNTS_BY_DATE,
        payload
    };
};

export const getStageCountsByDateSuccess = (payload) => {
    return {
        type: GET_STAGE_COUNTS_BY_DATE_SUCCESS,
        payload
    };
};

export const createMeetingHistory = (payload, callback) => {
    return {
        type: CREATE_MEETING_HISTORY,
        payload,
        callback
    }
}

export const createMeetingHistorySuccess = (payload) => {
    return {
        type: CREATE_MEETING_HISTORY_SUCCESS,
        payload
    }
}

export const getAllMeetingHistory = (projectId, historyType, callback) => ({
    type: GET_ALL_MEETING_HISTORY,
    projectId,
    historyType,
    callback
})

export const updateMeetingHistory = (id, payload, historyType, projectId, callback) => ({
    type: UPDATE_MEETING_HISTORY,
    id,
    payload,
    historyType,
    projectId,
    callback
})

export const updateMeetingHistorySuccess = (payload) => ({
    type: UPDATE_MEETING_HISTORY_SUCCESS,
    payload
})

export const getAllMeetingHistorySuccess = (payload) => ({
    type: GET_ALL_MEETING_HISTORY_SUCCESS,
    payload
})

export const createContract = (projectId, payload, callback) => {
    return {
        type: CREATE_CONTRACT,
        projectId,
        payload,
        callback
    }
}

export const createContractSuccess = (payload) => {
    return {
        type: CREATE_CONTRACT_SUCCESS,
        payload
    }
}

export const updateContract = (projectId, contractId, payload, callback) => {
    return {
        type: UPDATE_CONTRACT,
        projectId,
        contractId,
        payload,
        callback
    }
}

export const updateContractSuccess = (payload) => {
    return {
        type: UPDATE_CONTRACT_SUCCESS,
        payload
    }
}

export const deleteContract = (projectId, contractId, callback) => {
    return {
        type: DELETE_CONTRACT,
        projectId,
        contractId,
        callback
    }
}

export const deleteContractSuccess = (payload) => {
    return {
        type: DELETE_CONTRACT_SUCCESS,
        payload
    }
}

export const getAllContracts = (projectId) => {
    return {
        type: GET_ALL_CONTRACTS,
        projectId
    }
}

export const getAllContractsSuccess = (payload) => {
    return {
        type: GET_ALL_CONTRACTS_SUCCESS,
        payload
    }
}